import React from 'react';

const EmoticonIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M16 21.5c2.33 0 4.3-1.46 5.11-3.5H10.89c.8 2.04 2.78 3.5 5.11 3.5M12.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m7 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16 24a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-18C10.47 6 6 10.5 6 16a10 10 0 0 0 10 10c5.523 0 10-4.477 10-10A10 10 0 0 0 16 6z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default EmoticonIcon;
